<template>
  <page-error
    :buttonRedirect="''"
    :buttonText="$t('Refresh page')"
    :code="500"
    :message="$t('An internal error occurred. Please refresh the page.')"
    :title="$t('Internal server error')"
  />
</template>

<script>
  import PageError from '@/common/components/PageError.vue';

  export default {
    name: 'Error500',
    components: {
      PageError
    }
  };
</script>
